<!-- Loader Component -->
@if (!isLoaderHidden) {
<app-loader [isHidden]="false"></app-loader>
} @else {
<!-- Skip Link -->
<a href="#home" class="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 z-50 bg-accent text-white px-4 py-2 rounded font-mono text-sm">
  Skip to content
</a>

<!-- Toast Component -->
<app-toast></app-toast>

<!-- Main App Component -->
<app-header [activeSection]="(activeSection$ | async) ?? 'home'"></app-header>

<main class="grid-bg">
  <app-home></app-home>
  <app-about></app-about>
  <app-experience></app-experience>
  <app-education></app-education>
  <app-skills></app-skills>
  <app-projects></app-projects>
  <!-- <app-blog></app-blog> -->
  <app-contact></app-contact>
</main>

<app-footer></app-footer>

<!-- Social media links — vertical sidebar -->
<div class="hidden md:flex fixed left-5 top-1/2 -translate-y-1/2 z-50 flex-col items-center gap-1">
  <div class="w-px h-8 bg-subtle mb-2"></div>
  <a href="https://github.com/vnribeiro" target="_blank" aria-label="GitHub" title="GitHub" rel="noopener noreferrer"
    class="w-10 h-10 rounded-lg border border-subtle bg-surface-100/80 text-muted flex items-center justify-center hover:border-accent hover:text-accent transition-all duration-300 hover:-translate-y-0.5">
    <i class="fab fa-github text-sm"></i>
  </a>
  <a href="https://linkedin.com/in/vinicius-costa-azevedo-ribeiro" target="_blank" aria-label="LinkedIn"
    rel="noopener noreferrer" title="LinkedIn"
    class="w-10 h-10 rounded-lg border border-subtle bg-surface-100/80 text-muted flex items-center justify-center hover:border-accent hover:text-accent transition-all duration-300 hover:-translate-y-0.5">
    <i class="fab fa-linkedin text-sm"></i>
  </a>
  <a href="https://instagram.com/ribeirovn_" target="_blank" aria-label="Instagram" title="Instagram"
    rel="noopener noreferrer"
    class="w-10 h-10 rounded-lg border border-subtle bg-surface-100/80 text-muted flex items-center justify-center hover:border-accent hover:text-accent transition-all duration-300 hover:-translate-y-0.5">
    <i class="fab fa-instagram text-sm"></i>
  </a>
  <div class="w-px h-8 bg-subtle mt-2"></div>
</div>
}
